module.exports = __webpack_public_path__ + "img/spitter-attack-2.9734d639.png";